import { Text, View } from '@react-pdf/renderer'
import { blankFooterStyles } from './blankFooterStyles';

export const BlankFooter = ({ data, showTranslatedText }: any) => {

    const { blankFooter } = blankFooterStyles();

    return (
        <View style={blankFooter.container}>
            <View style={blankFooter.notesContainer}>
                <Text style={{fontWeight:700, fontSize:6}}>{showTranslatedText("reports.salesPreorderPdf.footer.notes")}:</Text>
                <Text style={{ fontSize: 6 }}>{data.dataSalesPreorders.notes}</Text>
            </View>
            <View style={blankFooter.messageContainer}>
                <Text style={blankFooter.message}>{showTranslatedText("reports.salesPreorderPdf.footer.continueToTheNextPage")}</Text>
            </View>
        </View>
    )
}
